<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <filterByStatus pageTitle="ĐỊNH NGHĨA QUY TRÌNH" />
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <div class="list-docs wrapper-content__main">
          <subHeader>
            <template #content>
              <div class="leftSection">
              </div>
              <searchTemplate
                :keyword="searchKey"
                @simpleSearch="search"
                :isDisableAdvanceSearch="true"
              ></searchTemplate>
            </template>
          </subHeader>

          <div>
            <el-form inline-message>

              <el-form-item>
                <span class="label-input">Quy trình</span>
                <el-select
                  v-model="flowCode"
                  placeholder="Chọn quy trình">
                  <el-option
                    v-for="item in flowCodes"
                    :key="item.flowCode"
                    :label="item.flowName"
                    :value="item.flowCode">
                  </el-option>
                </el-select>

                <span class="label-input">Đơn vị</span>
                <el-select
                  filterable
                  v-model="department"
                  placeholder="Chọn đơn vị">
                  <el-option
                    v-for="item in departments"
                    :key="item.id"
                    :label="item.deptName + ' - ' + item.parentName"
                    :value="item.id">
                  </el-option>
                </el-select>

              </el-form-item>
            </el-form>
          </div>

          <listDept
            @viewDetail="viewDetailMissing"
            :data="missingData"
            title="Danh sách đơn vị chưa khai báo quy trình"
          ></listDept>

          <listDept
            @viewDetail="viewDetailDone"
            :data="doneData"
            title="Danh sách đơn vị đã khai báo quy trình"
          ></listDept>

          <createRegisterRoomDialog
            :isOpen="isOpenDialogCreate"
            :id="selectedRoomId"
            :flowId="flowId"
            :flowCode="flowCode"
            v-if="isEnableDialogCreate"
            @dialogClosed="isEnableDialogCreate = false"
            @closeDialog="closeDialog"
            @success="createDialogSuccess"
          />
        </div>
      </div>
    </template>
  </listTemplate>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import headerTemplate from "../../../components/header/main-header.vue";
import listTemplate from "../../common/list";
import searchTemplate from "../../common/search.vue";
import listDept from "./listDept";
import hanhchinhService from "../../../services/hanhchinhService";
import departmentService from "../../../services/departmentService";
import utils from "../../../services/utils";
import { EventBus } from "../../../event-bus.js";

export default {
  components: {
    headerTemplate,
    searchTemplate,
    listDept,
    listTemplate,
    VueCtkDateTimePicker,
    filterByStatus: () => import('../components/filter-by-status-header.vue'),
    subHeader: () => import("../../../components/main/sub-header.vue"),
    createRegisterRoomDialog: () => import("./PhongHop_Form.vue")
  },

  created() {
    this.checkMissingFlow(this.flowCode, this.department);
    departmentService.findAll().then(response => {
        this.departments = response.data;
        this.department = this.departments[0].id;
    });

    EventBus.$on("reloadPage", options => {
        this.checkMissingFlow(this.flowCode, this.department);
    });
  },

  watch: {
    isOpenDialogCreate(newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },

    isEnableDialogCreate(newValue) {
      !newValue && (this.selectedRoomId = null);
    },

    flowCode(newValue) {
      this.checkMissingFlow(this.flowCode, this.department);
    },

    department(newValue) {
      this.checkMissingFlow(this.flowCode, this.department);
    }
  },
  data() {
    return {
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      searchKey: null,
      missingData: [],
      doneData: [],
      flowCode: 'PHONG_HOP',
      flowCodes : [
        {flowCode: 'PHONG_HOP', flowName: 'Đăng ký phòng họp'},
        {flowCode: 'PHONG_HOP_DX', flowName: 'Đăng ký phòng họp đột xuất'},
        {flowCode: 'DIEU_XE', flowName: 'Đăng ký điều xe'},
        {flowCode: 'DIEU_XE_DX', flowName: 'Đăng ký điều xe đột xuất'},
        {flowCode: 'CHI_DAO', flowName: 'Theo dõi chỉ đạo của LĐ'},
        {flowCode: 'LICH_TUAN', flowName: 'Đăng ký lịch tuần'},
        {flowCode: 'VEMAYBAY', flowName: 'Đăng ký vé máy bay'},
        {flowCode: 'KHACH_SAN', flowName: 'Đăng ký khách sạn'},
        {flowCode: 'CONG_VIEC_TRONG_TAM', flowName: 'Công việc trọng tâm'},
        {flowCode: 'QUY_CHE_QUY_DINH', flowName: 'Quy chế quy định'}
      ],
      department: null,
      departments : []
    };
  },
  methods: {

    viewDetailMissing(e) {
      let deptId = e.item.deptId;
      let flowCode = e.item.flowCode;
      let params = utils.merge(this.$route.params, { deptId: deptId, flowCode: flowCode });
      this.$router.push({
        name: "administration-tools-detail",
        params: params,
        query: null
      });
    },

    viewDetailDone(e) {
      let deptId = e.item.deptId;
      let flowCode = e.item.flowCode;
      let params = utils.merge(this.$route.params, { deptId: deptId, flowCode: flowCode });
      this.$router.push({
        name: "administration-tools-detail",
        params: params,
        query: null
      });
    },

    closeDialog() {
      this.isOpenDialogCreate = false;
    },

    createDialogSuccess() {
      this.isOpenDialogCreate = false;
    },

    checkMissingFlow(flowCode, deptId) {
      return hanhchinhService
        .checkMissingFlow(flowCode, deptId)
        .then(response => {
          this.missingData = this.flatMissingData([], response.data);
          this.doneData = this.flatDoneData([], response.data);
        });
    },

    flatMissingData(result, data) {
      if (typeof data === 'object' && isNaN(data.length)) {  // Object
        let obj = {
          rs : data.rs,
          deptId : data.deptId,
          deptName : data.deptName,
          flowCode : data.flowCode,
          level : data.level
        };
        if (data.rs === false) {
          result.push(obj);
        }
        if (typeof data.missing === 'object' && !isNaN(data.missing.length)) {
          this.flatMissingData(result, data.missing);
        }
        return result;
      } else if (typeof data === 'object' && !isNaN(data.length)) {    // Array
        for (let i=0; i<data.length; i++) {
          let obj = {
            rs : data[i].rs,
            deptId : data[i].deptId,
            deptName : data[i].deptName,
            flowCode : data[i].flowCode,
            level : data[i].level
          };
          result.push(obj);
          if (typeof data[i].missing === 'object' && !isNaN(data[i].missing.length)) {
            this.flatMissingData(result, data[i].missing);
          }
        }
        return result;
      }
    },

    flatDoneData(result, data) {
      if (typeof data === 'object' && isNaN(data.length)) {  // Object
        let obj = {
          rs : data.rs,
          deptId : data.deptId,
          deptName : data.deptName,
          flowCode : data.flowCode,
          level : data.level
        };
        if (data.rs === true) {
          result.push(obj);
        }
        if (typeof data.done === 'object' && !isNaN(data.done.length)) {
          this.flatDoneData(result, data.done);
        }
        return result;
      } else if (typeof data === 'object' && !isNaN(data.length)) {    // Array
        for (let i=0; i<data.length; i++) {
          let obj = {
            rs : data[i].rs,
            deptId : data[i].deptId,
            deptName : data[i].deptName,
            flowCode : data[i].flowCode,
            level : data[i].level
          };
          result.push(obj);
          if (typeof data[i].done === 'object' && !isNaN(data[i].done.length)) {
            this.flatDoneData(result, data[i].done);
          }
        }
        return result;
      }
    },

    search(keyword) {
      alert(keyword);
    }

  }
};
</script>

<style scoped>
.filterBtngroup {
  display: flex;
}

.filterBtn {
  padding: 10px 30px;
  box-shadow: 0 4px 3px -3px #dcdcdc;
}

.filterBtn:hover {
  background-color: #025cab;
  color: #fff;
}

.filterBtn:focus {
  background-color: #025cab;
  color: #fff;
}

.actived {
  background-color: #025cab;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/tools/Tool_Index.vue